<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :onClose="onClose">
    <label class="generalLabel" for="surname">Apellido</label>
    <input type="text" class="form-control generalInput" id="surname"
      v-model.trim.lazy="v$.surname.$model" autocomplete="off">
    <div v-if="v$.surname.$dirty">
      <small class="form-text text-danger" v-if="v$.surname.required.$invalid">Campo requerido</small>
    </div>
    <div class="custom-control custom-checkbox mt-2">
      <input type="checkbox" class="custom-control-input" id="bankReader" v-model.trim="bankReader" />
      <label class="custom-control-label" for="bankReader">Bank reader</label>
    </div>
    <button class="btn btn-primary generalPrimaryButton float-right mt-5" aria-label="Close"
      :disabled="v$.$invalid" @click="modifiedData()">Confirmar</button>
    <button :id="id+'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>

<script>

import Modal from '../../Shared/Modal.vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators'
import axios from 'axios';

export default {
  name: 'EditSurname',
  setup() {
    return { v$: useVuelidate() }
  },
  props: [
    'id',
    'modalTitle',
    'class',
    'list'
  ],
  data() {
    return {
      classes: this.class,
      surname: this.list.surname,
			bankReader: this.list.bankReader || false
    }
  },
  validations() {
    return {
      surname: {
        required,
      },
    }
  },
  components: {
    Modal,
  },
  methods: {
    modifiedData() {
      let bodyToSend = {
        legalIdentifier: this.list.legalIdentifier,
        mobile: this.list.mobile,
        email: this.email,
        street: this.list.street,
        number: this.list.number,
        postalCode: this.list.postalCode,
        city: this.list.city,
        province: this.list.province,
        surname: this.surname,
        bankReader: this.bankReader,
      }
      axios.patch(`/customer/blacklist-update-surname/${this.list.surname}`, bodyToSend)
        .then(() => {
          axios.get(`/customer/blacklist-surname/${bodyToSend.surname}`)
            .then((response) => {
              this.$emit("refreshRegisterList", response.data);
              this.onClose();
            });
        });
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
